<div [formGroup]="form" class="flex items-center gap-x-[3px] text-xs font-normal">
  <button
    type="button"
    (click)="decrement()"
    [disabled]="quantity <= 1"
    [ngClass]="['border-verde disabled:border-grisTinku w-[28.6px] h-[28.6px] rounded text-verde disabled:text-grisTinku hover:text-cafe disabled:cursor-not-allowed',
    buttonDecrementPressed() ? 'border' : 'border-[0.72px]']"
  >
    −
  </button>
<!--(keydown.enter)="changeQuantity()"-->
  <input
    type="text"
    maxlength="4"
    pattern="\d*"
    formControlName="quantity"
    (keyup)="startChangesTimer($event)"
    (paste)="onPaste($event)"
    class="w-[43px] h-[28.6px] hide-number-arrow border-[0.72px] border-cafe focus:outline-verde  focus:border-[#372121] text-center justify-center rounded"
  />

  <button
    type="button"
    (click)="increment()"
    [ngClass]="['border-verde w-[28.6px] h-[28.6px] rounded text-verde hover:text-cafe', buttonIncrementPressed() ? 'border' : 'border-[0.72px]']"
  >
    +
  </button>
</div>

